<template>
  <div class="form-group document-check-list-item">
    <h5 class="uk-text-bold mb-2">
      {{ $t('general.explanatory_text') }} <span class="required">*</span>
    </h5>
    <textarea 
      :value="description"
      @input="$emit('update:description', $event.target.value)"
      class="form-control" 
      name="short_description"
    ></textarea>
    
    <form v-for="(item, index) in items" :key="index" class="mt-4">
      <h5 class="uk-text-bold mb-2">
        <i class="uil-check-square"></i> {{ index + 1 }}.
        {{ $t('general.control_article') }}
        <span class="required">*</span>
      </h5>
      <div class="row">
        <div class="col-md-8">
          <input 
            :value="item.name"
            @input="updateItemName(index, $event.target.value)"
            class="form-control" 
            type="text" 
            @keydown.enter="onEnter"
          />
        </div>
        <div class="col-md-4" style="text-align: end">
          <div class="uk-grid uk-grid-small d-flex align-items-center justify-content-between" uk-grid>
            <div class="d-flex align-items-center">
              <div class="uk-width-auto">
                <label class="uk-switch mb-0">
                  <input 
                    :checked="item.is_mandatory"
                    @change="updateItemMandatory(index, $event.target.checked)"
                    type="checkbox" 
                  />
                  <div class="uk-switch-slider uk-switch-small"></div>
                </label>
              </div>
              <div class="uk-width-expand">
                <small class="ml-2">{{$t('general.mandatory_to_mark')}}</small>
              </div>
            </div>
            <button 
              class="btn btn-light bg-light" 
              :uk-tooltip="'title: ' + $t('general.remove')"
              type="button"
              @click="$emit('remove-item', index)"
            >
              <i class="uil-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
    
    <div class="mt-3">
      <button 
        class="uk-button uk-button-outline" 
        style="width: 100%" 
        type="button"
        @click="$emit('add-item')"
      >
        <i class="uil-plus"></i> {{ $t('general.add_control') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentCheckListItem",
  props: {
    description: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onEnter(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    updateItemName(index, value) {
      const updatedItems = [...this.items];
      updatedItems[index] = {
        ...updatedItems[index],
        name: value
      };
      this.$emit('update:items', updatedItems);
    },
    updateItemMandatory(index, value) {
      const updatedItems = [...this.items];
      updatedItems[index] = {
        ...updatedItems[index],
        is_mandatory: value
      };
      this.$emit('update:items', updatedItems);
    }
  }
};
</script>

